import React from 'react';
import "../App.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Card from 'react-bootstrap/Card';
import "./TopD.css";


const TopD = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 900,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4990,
    cssEase: "ease-out",
    responsive: [
      {
        breakpoint: 1274,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        }
      },
      {
        breakpoint: 690,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
          infinite: true,
          dots: false,
        }
      },
      {
        breakpoint: 460,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        }
      },
    ]
  };

  return (
    <>
      <div className='maintopd '>
        <div className='topdtext'>
          <h5>
            Top Properties
          </h5>
          <p>
            Where sophistication meets comfort
            <br />Your luxury dream home!
          </p>
        </div>

        <div className='topdslider'>
          <Slider {...settings}>

            <a href ="/bs">
              <Card className='maincard' style={{ borderRadius: '10px' }}>
                <video className="sliderimg card-video-top" src="/assets/Gadh1.mp4" autoPlay muted loop playsInline />
                <Card.Body className='cardbody'>
                  <Card.Text className='cardtitle mb-0 mt-0 fs-3'>Best Sellers</Card.Text>
                  <Card.Text className='sliderhotels cardtext'>Garh Mukteshwar, U.P</Card.Text>
                </Card.Body>
              </Card>
            </a>

            <a href="/inv">
              <Card className='maincard' style={{ borderRadius: '10px' }} >
                <video className="sliderimg card-video-top" src="/assets/inv1.mp4" autoPlay muted loop playsInline />
                <Card.Body className='cardbody'>
                  <Card.Text className='cardtitle mb-0 mt-0 fs-3'>Investment</Card.Text>
                  <Card.Text className='sliderhotels cardtext'>Dholera, Gujarat</Card.Text>
                </Card.Body>
              </Card>
            </a>

            <a href="/pl">
              <Card className='maincard' style={{ borderRadius: '10px' }} href="/pl">
                <video className="sliderimg card-video-top" src="/assets/Mussoorie 1.mp4" autoPlay muted loop playsInline />
                <Card.Body className='cardbody'>
                  <Card.Text className='cardtitle mb-0 mt-0 fs-3'>Prime Location</Card.Text>
                  <Card.Text className='sliderhotels cardtext'>Mussoorie, Uttarakhand</Card.Text>
                </Card.Body>
              </Card>
            </a>

            <a href="/com">
              <Card className='maincard' style={{ borderRadius: '10px' }}>
                <video className="sliderimg card-video-top" src="/assets/com.mp4" autoPlay muted loop playsInline />
                <Card.Body className='cardbody'>
                  <Card.Text className='cardtitle mb-0 mt-0 fs-3'>Commercials</Card.Text>
                  <Card.Text className='sliderhotels cardtext'>Noida, U.P</Card.Text>
                </Card.Body>
              </Card>
            </a>

         
          </Slider>
        </div>
      </div>
    </>
  )
}

export default TopD;
